import { Controller } from 'stimulus'
import { useClickOutside } from 'stimulus-use'
import * as basicLightbox from 'basiclightbox'

export default class extends Controller {
  // static values = {
  //   url: String
  // }
  // static classes = ['handle','draggable']
  // static targets = ['navi']

  connect() {
    this.instance = basicLightbox.create(document.querySelector('template.lightbox'))
    useClickOutside(this)
  }

  show(event) {
    event.preventDefault()
    this.current = event.currentTarget
    let pic_url = event.currentTarget.href
    this.instance.element().querySelector('img').src = pic_url
    this.instance.show()
  }

  clickOutside(event) {
    if (!event.target.parentElement.parentElement.classList.contains('basicLightbox__placeholder')) { return }

    if (event.target.classList.contains('next')) {
      event.preventDefault()
      this.next()
    }
    if (event.target.classList.contains('prev')) {
      event.preventDefault()
      this.prev()
    }
    if (event.target.classList.contains('close')) {
      event.preventDefault()
      this.close()
    }
  }

  next() {
    let next = this.current.closest('.picture').nextElementSibling
    if (next && next.classList.contains('picture')) {
      this.changeTo(next)
    }
  }

  prev() {
    let prev = this.current.closest('.picture').previousElementSibling
    if (prev && prev.classList.contains('picture')) {
      this.changeTo(prev)
    }
  }

  changeTo(new_item) {
    let image_link = new_item.querySelector('a')
    this.current = image_link
    let pic_url = image_link.href
    this.instance.element().querySelector('img').src = pic_url
  }

  close() {
    this.instance.close()
  }
}
